var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.02,
    height: 18.026,
    viewBox: "0 0 21.02 18.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2742787_announcement_business_marketing_seo_chart_icon",
    "data-name": "2742787_announcement_business_marketing_seo_chart_icon",
    transform: "translate(-4.1 -8.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M4.1,30.586v.762a3.576,3.576,0,0,0,3.339,3.563v5.356a.66.66,0,0,0,.672.672h2.375a.66.66,0,0,0,.672-.672V34.933h.381V27H7.686A3.6,3.6,0,0,0,4.1,30.586Z",
    transform: "translate(0 -14.153)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M56.1,8.881a.632.632,0,0,0-.627-.067L44.4,13.52v6.566l11.07,4.706a.677.677,0,0,0,.874-.359.568.568,0,0,0,.045-.269V9.441A.7.7,0,0,0,56.1,8.881Z",
    transform: "translate(-31.269 0)",
    fill: "#37bdb0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/Advertising.20c66226fd1051f82740429be88e0629.svg";
export { ForwardRef as ReactComponent };